export const selectRatings = (state) => state.ratings.values;